function PrivacyPolicy() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <header className="p-4 md:flex md:justify-between md:items-center bg-white shadow-sm">
                <div className="font-bold text-xl text-center">
                    <i className="far fa-wave-pulse mr-2 text-teal-700"></i>
                    Home<span className="text-teal-700">Pulse</span>
                </div>
                <div className="hidden md:block">
                    <a href="/" className="px-4 py-2 rounded-md border-teal-700 text-teal-700 border rounded-md font-semibold cursor-pointer">
                        <i className="far fa-arrow-left mr-2"></i>
                        Back to Home
                    </a>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-4xl mx-auto p-6 py-12">
                <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
                    {/* Title */}
                    <div className="text-center mb-12">
                        <h1 className="text-3xl md:text-4xl font-bold text-teal-900 mb-4">
                            Privacy Policy
                        </h1>
                        <p className="text-lg text-teal-800">
                            Last Updated: August 4, 2025
                        </p>
                    </div>

                    {/* Privacy Policy Section */}
                    <section className="mb-12" id="privacy-policy">
                        <h2 className="text-2xl font-bold text-teal-900 mb-6">Privacy Policy</h2>
                        
                        <div className="space-y-6 text-gray-700 leading-relaxed">
                            <div>
                                <h3 className="text-xl font-semibold text-teal-800 mb-3">Introduction</h3>
                                <p className="mb-4">
                                    DICE Digital ("Company", "we", or "us") operates the HomePulseTracker service ("HomePulseTracker" or the "Service"). 
                                    HomePulseTracker allows users to sign up with their email and home address to receive a free monthly email detailing 
                                    changes to their home's estimated value using data from third-party real estate services like Zillow, Realtor.com, and Redfin. 
                                    We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains what 
                                    information we collect, how we use and share it, and your choices regarding your information.
                                </p>
                            </div>

                            <div>
                                <h3 className="text-xl font-semibold text-teal-800 mb-3">Information We Collect</h3>
                                <div className="space-y-4">
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Personal Information You Provide:</h4>
                                        <p className="mb-3">
                                            When you sign up for HomePulseTracker, we collect only the personal information needed to provide the service, specifically:
                                        </p>
                                        <ul className="list-disc list-inside space-y-2 ml-4">
                                            <li><strong>Email Address</strong> – used to send you the monthly home value update reports.</li>
                                            <li><strong>Home Address</strong> – used to retrieve your property's value estimates from third-party real estate data providers.</li>
                                        </ul>
                                        <p className="mt-3">
                                            We do not collect any other personal identifiers such as your name, phone number, or payment information 
                                            (the Service is completely free to use). If you contact us (for example, via support email), we will collect 
                                            your email address and any other information you choose to provide in that correspondence, solely to assist you with your inquiry.
                                        </p>
                                    </div>
                                    
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Automatically Collected Data:</h4>
                                        <p>
                                            HomePulseTracker does not use any tracking cookies or analytics scripts to collect personal data about your browsing. 
                                            We may receive basic log information (such as IP addresses or browser type) automatically from your visit to our website 
                                            for security and debugging purposes, but we do not use this information to identify you or track your activities across sites.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h3 className="text-xl font-semibold text-teal-800 mb-3">How We Use Your Information</h3>
                                <p className="mb-4">
                                    We use the collected information for the following purposes:
                                </p>
                                <div className="space-y-4">
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Providing the Service:</h4>
                                        <p>
                                            Your email and address are used to deliver the core service – a monthly email report with updates on your home's estimated value. 
                                            We use your provided home address to query third-party real estate data sources (e.g., Zillow, Realtor.com, Redfin) via their 
                                            APIs in order to obtain the latest value estimates for that property. Your email address is then used to send you the report 
                                            containing that information.
                                        </p>
                                    </div>
                                    
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Service Communications:</h4>
                                        <p>
                                            We may use your email to send important administrative or service-related messages, such as updates about changes to the Service, 
                                            policy updates, or confirmations (for example, confirming your subscription or unsubscription). We will not send you marketing 
                                            or promotional emails unrelated to the HomePulseTracker service without your consent.
                                        </p>
                                    </div>
                                    
                                    <div>
                                        <h4 className="font-semibold text-teal-700 mb-2">Improvement and Analytics:</h4>
                                        <p>
                                            We might use information in an aggregated, non-identifiable form to understand how our service is used (for example, the number 
                                            of subscribers or general usage trends) in order to improve HomePulseTracker. These analytics will not identify any individual user.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-teal-50 rounded-lg p-6 mt-12">
                        <h3 className="text-xl font-semibold text-teal-900 mb-4">Contact Us</h3>
                        <div className="space-y-2 text-gray-700">
                            <p><strong>Email:</strong> support@homepulsetracker.com</p>
                            <p><strong>Company:</strong> DICE Digital (Inc.), incorporated in the State of Georgia, USA</p>
                            <p className="text-sm text-gray-600">
                                If you have any questions, concerns, or requests regarding this Privacy Policy or your personal information, 
                                please contact us. We will do our best to address any issue or inquiry promptly.
                            </p>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}

export default PrivacyPolicy;